import { commentClips } from "@/mocks/hotTopics";

const stanceTone: Record<string, string> = {
  accent: "bg-accent-100 text-accent-900",
  primary: "bg-primary-100 text-primary-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function CommentClips() {
  return (
    <section id="clips" className="bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              评论区 · 高赞切片
            </p>
            <h4 className="flex items-center gap-3 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              <a href="#clips" className="flex items-center gap-3">
                评论区高赞名场面
              </a>
            </h4>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-foreground-500">
            被最多人顶上去的一句话。一条切片，就是当下网友最真实的观点截面。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {commentClips.map((c) => (
            <article
              key={c.user}
              className="group-card flex flex-col rounded-xl border border-background-200 bg-background-100/40 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="rounded-full bg-background-50 px-2.5 py-1 text-[11px] font-medium text-foreground-500">
                  <i className="ri-quote-text mr-1 text-primary-500" />
                  {c.topic}
                </span>
                <span className={`rounded-full px-2 py-1 text-[11px] font-semibold ${stanceTone[c.tone]}`}>
                  {c.stance}
                </span>
              </div>

              <blockquote className="mt-4 flex-1 border-l-2 border-primary-400 pl-3 text-[15px] font-medium leading-relaxed text-foreground-800">
                {c.quote}
              </blockquote>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-200 text-[11px] font-bold text-foreground-600">
                    {c.user.slice(0, 1)}
                  </span>
                  网友 · {c.user}
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-heart-3-fill" />
                  {c.likes.toFixed(1)}万赞
                </span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-5 text-center text-xs text-foreground-400">
          评论切片仅节选代表性观点用于氛围展示，昵称已作部分打码处理
        </p>
      </div>
    </section>
  );
}